// @ts-ignore
import classes from './toggle.css'
import { dataHook } from '../../utils'

export const TOGGLE_ROOT_HOOK = 'toggle-root'

type InitialCheckedState = 'checked' | ''
export const createToggleTemplate = (
  modifier: string,
  inputHook: string,
  labelHook = '',
  initialChecked: InitialCheckedState = '',
  aria?: string,
) =>
  `<span class="${classes.toggle} ${modifier}" ${dataHook(TOGGLE_ROOT_HOOK)}>
  <input 
  ${dataHook(inputHook)} 
  id="${inputHook}" 
  class="${classes.input}" 
  type="checkbox" 
  ${initialChecked} 
  ${aria} 
  onKeyDown="(function(event){
    if (event.keyCode === 13) { // Check if Enter key is pressed
      this.checked = !this.checked; // Toggle the checkbox
    }
  }).call(this, event)" 
/>
  <label ${dataHook(labelHook)} for="${inputHook}" class="${classes.label}">
    <span class="${classes.track}"></span>
    <span class="${classes.knob}">
      <svg class="${classes.icon} ${
    classes.iconFalse
  }" viewBox="0 0 11 2" fill="currentColor" width="10" height="2"><path d="M0 0H10V2H0z"></path></svg>
      <svg class="${classes.icon} ${
    classes.iconTrue
  }" viewBox="0 0 11 8" fill="currentColor" width="10" height="8"><path d="M3.8 5L1.2 2.5 0 3.7 3.8 7.5 10 1.2 8.8 0z"></path></svg>
    </span>
  </label>
</span>`
